import { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const PixelFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading,
  mode = "create",
  initialData = null,
}) => {
  const [form, setForm] = useState({
    name: "",
    type: "facebook",
    pixel_id: "",
    // is_future_use: false,
  });

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setForm({
        name: initialData.name || "",
        type: initialData.type || "facebook",
        pixel_id: initialData.pixel_id || "",
        // is_future_use: initialData.is_future_use || false,
      });
    }

    if (mode === "create") {
      setForm({
        name: "",
        type: "facebook",
        pixel_id: "",
        // is_future_use: false,
      });
    }
  }, [mode, initialData]);

  if (!isOpen) return null;

  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">
            {mode === "edit" ? "Edit Pixel" : "Add Pixel"}
          </h2>

          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          <div>
            <label className="block text-sm text-slate-300 mb-1">
              Pixel Name
            </label>
            <input
              type="text"
              placeholder="Pixel name"
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-1">
              Select Pixel Type
            </label>
            <select
              value={form.type}
              onChange={(e) => handleChange("type", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            >
              <option value="facebook">Facebook</option>
              <option value="tiktok">Tiktok</option>
            </select>
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-1">
              Pixel Id
            </label>
            <input
              type="text"
              placeholder="Pixel Id"
              value={form.pixel_id}
              onChange={(e) => handleChange("pixel_id", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </div>

          {/* <div className="flex items-center">
            <label
              htmlFor="is_future_use"
              className="text-sm text-slate-300 mr-4"
            >
              Is Future Use
            </label>

            <div className="flex gap-6">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  className="accent-pink-600"
                  checked={form.is_future_use === true}
                  onChange={() => handleChange("is_future_use", true)}
                />
                Yes
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  className="accent-pink-600"
                  checked={form.is_future_use === false}
                  onChange={() => handleChange("is_future_use", false)}
                />
                No
              </label>
            </div>
          </div> */}
        </div>

        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800 transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`px-4 py-2 text-sm rounded-lg text-white font-medium transition
              ${
                loading
                  ? "bg-pink-400 cursor-not-allowed"
                  : "bg-pink-600 hover:bg-pink-700"
              }
            `}
          >
            {loading
              ? "Saving..."
              : mode === "edit"
                ? "Update Pixel"
                : "Create Pixel"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PixelFormModal;
